import ManufactureComponents from './ManufactureComponents';

export default ManufactureComponents;
